import PostsAdapter from './base';

export default class Attendancenote extends PostsAdapter {
  modelNamePlural = 'attendancenotes';
}
